import { useLoaderData, useNavigate } from "react-router";
import SignupForm from "../../components/sign-up/sign-up-form";
import { useEffect } from "react";
import { errorHandler } from "../../helpers/errorHelper";

export default function HomePage() {
  const data = useLoaderData();
  const navigate = useNavigate();

  useEffect(() => {
    if (!data?.result && data?.error) {
      errorHandler(data, navigate);
    }
  }, []);

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="mb-4 font-bold text-red">Enter</h1>
      <p className="mx-auto mb-6 max-w-xs text-center text-red">
        With your Costa Express drink you have the chance to win prizes every
        day – from shopping vouchers, free coffee, cinema tickets and even a
        holiday! See more about our prizes{" "}
        <a style={{ textDecoration: "underline" }} href="/prizes">
          here
        </a>
        . 
      </p>

      <h2 className="text-red mx-auto mb-6 max-w-xs text-center font-bold">
        Fill in your details below to enter. {" "}
      </h2>

      <h2 className="mx-auto mb-7 max-w-xs text-center font-light  text-red">
        Please note you must be over 18 to enter.
      </h2>
      <SignupForm />
    </div>
  );
}
